// extracted by mini-css-extract-plugin
module.exports = {"card":"OptionCard_card__29hH5","iconWrap":"OptionCard_iconWrap__1NSmb","label":"OptionCard_label__dngoR","disabled":"OptionCard_disabled__1oOLE"};